import styled from 'styled-components';
import { colors, spacing, H4, Body2 } from 'ui/theme';
import { RadioGroup } from 'ui/radioGroup/radioGroup';

export const TakeoverBodyHeader = styled.div`
  padding: ${spacing.base};
  border-bottom: 1px solid ${colors.grey15};
`;

export const BodyContent = styled.div`
  padding: ${spacing.base};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  padding-top: ${spacing.quarter};
`;

export const ErrorStateWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  padding: ${spacing.x3} ${spacing.double};
  text-align: center;
  gap: ${spacing.base};

  ${H4} {
    margin: 0;
  }
`;

export const ErrorStateBody = styled(Body2)`
  color: ${colors.textSecondary};
  max-width: 461px;
  margin: 0;
`;

export const CenteredLoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
  padding: 20px;
`;
